export const notificationDrawer = {
  notificationDrawerTitle: "Notificaciones",
  notificationDrawerDeleteBtn: "Eliminar",
  notificationDrawerDeletedNotification: "Notificación eliminada",
  notificationDrawerDeletedFailed: "Eliminar notificación falló",
  notificationMarkReadFailed: "Marcar notificación como leída falló",
  notificationDrawerNotifications: "Sin notificaciones",
  notificationDrawerPlay: "Jugar",
  notificationDrawerPlayGame: "Ir al juego",
};
